exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-6401ab62]{background:#000;opacity:.7}.overlay-enter[data-v-6401ab62],.overlay-leave-to[data-v-6401ab62]{opacity:0}.overlay-enter-active[data-v-6401ab62],.overlay-leave-active[data-v-6401ab62]{transition:all .3s}", ""]);

// exports
